import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "max-w-full flex" }
const _hoisted_2 = { class: "mr-5 truncate max-w-[65%]" }
const _hoisted_3 = { class: "flex-shrink-0 absolute inset-y-1 right-1" }
const _hoisted_4 = { class: "m-2 flex-grow flex-shrink-0" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "3",
  stroke: "currentColor",
  class: "w-4 h-4"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M4.5 12.75l6 6 9-13.5"
  })
], -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "3",
  stroke: "currentColor",
  class: "w-4 h-4"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M6 18L18 6M6 6l12 12"
  })
], -1)
const _hoisted_8 = [
  _hoisted_7
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["widget relative flex rounded-lg p-2 bg-gray-200 mt-1 mb-1 mr-1 max-w-full", {
                        'bg-green-400 transition-colors duration-100': _ctx.course.completed
                    }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.course.name_sv), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.course.credits), 1),
      _createElementVNode("button", {
        class: "rounded bg-blue-500 hover:bg-blue-600 text-white p-1 m-1 transition-colors duration-100 active:bg-blue-700 text-white p-1 m-1 transition transform duration-150 ease-in-out active:scale-95",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.completeButton(_ctx.course)))
      }, _hoisted_6),
      _createElementVNode("button", {
        class: "rounded bg-red-400 hover:bg-red-500 text-white p-1 m-1 transition-colors duration-100 active:bg-red-500 text-white p-1 m-1 transition transform duration-150 ease-in-out active:scale-95",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.removeButton(_ctx.course)))
      }, _hoisted_8)
    ])
  ], 2))
}